/**
 * @generated SignedSource<<31c006cf09f6064b0becfee26b025a7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentSystemTaskKind = "add_events_to_calendar" | "calendar_connection" | "community_agreement" | "complete_profile" | "connect_slack" | "custom_profile_field" | "default_profile_fields" | "download_mobile_app" | "onboarding_complete" | "onboarding_module" | "onboarding_welcome" | "slack_connection" | "slack_invite" | "%future added value";
export type MemberOnboardingBannerQuery$variables = {
  includeDraft?: boolean | null;
  membershipId: string;
  organizationId: string;
  shouldOnboard: boolean;
};
export type MemberOnboardingBannerQuery$data = {
  readonly memberOnboarding?: {
    readonly content: {
      readonly children: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly content: {
              readonly id: string;
              readonly systemTaskKind: ContentSystemTaskKind | null;
            };
            readonly id: string;
            readonly viewerHasCompleted: boolean;
          };
        }>;
      } | null;
      readonly id: string;
    };
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingBannerRefetchableFragment_usage" | "MemberOnboardingModalFragment">;
  } | null;
  readonly organization: {
    readonly id?: string;
    readonly isMemberOnboardingRequired?: boolean;
  } | null;
};
export type MemberOnboardingBannerQuery = {
  response: MemberOnboardingBannerQuery$data;
  variables: MemberOnboardingBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDraft"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldOnboard"
},
v4 = [
  {
    "kind": "Variable",
    "name": "membershipId",
    "variableName": "membershipId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "includeDraft",
    "variableName": "includeDraft"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasCompleted",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemTaskKind",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "organizationId"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMemberOnboardingRequired",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordering",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = [
  (v5/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v18 = [
  (v5/*: any*/),
  (v15/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v20 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  },
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MemberOnboardingBannerQuery",
    "selections": [
      {
        "condition": "shouldOnboard",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "ContentUsage",
            "kind": "LinkedField",
            "name": "memberOnboarding",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MemberOnboardingBannerRefetchableFragment_usage"
              },
              {
                "args": (v6/*: any*/),
                "kind": "FragmentSpread",
                "name": "MemberOnboardingModalFragment"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": (v6/*: any*/),
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": "organization",
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              (v10/*: any*/)
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "MemberOnboardingBannerQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/)
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "shouldOnboard",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "ContentUsage",
            "kind": "LinkedField",
            "name": "memberOnboarding",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": (v6/*: any*/),
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v12/*: any*/),
                              (v7/*: any*/),
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v8/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "description",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "coverPhoto",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "coverVideo",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Asset",
                                    "kind": "LinkedField",
                                    "name": "coverVideoAsset",
                                    "plural": false,
                                    "selections": (v16/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssetUsage",
                                    "kind": "LinkedField",
                                    "name": "coverVideoAssetUsage",
                                    "plural": false,
                                    "selections": (v16/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "richEditorDescriptionContent",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentMentionNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "mentions",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentMentionNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentMention",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "fullName",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MemberGroup",
                                                "kind": "LinkedField",
                                                "name": "memberGroup",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  (v15/*: any*/),
                                                  (v17/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "role",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Product",
                                                "kind": "LinkedField",
                                                "name": "mentionedProduct",
                                                "plural": false,
                                                "selections": (v18/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ContentUsage",
                                                "kind": "LinkedField",
                                                "name": "mentionedContentUsage",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": (v18/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Occurrence",
                                                "kind": "LinkedField",
                                                "name": "mentionedOccurrence",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  (v15/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": [
                                                      (v15/*: any*/),
                                                      (v5/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__id",
                                            "storageKey": null
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v6/*: any*/),
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v13/*: any*/),
                                              (v7/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Content",
                                                "kind": "LinkedField",
                                                "name": "content",
                                                "plural": false,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ProfileField",
                                                    "kind": "LinkedField",
                                                    "name": "profileField",
                                                    "plural": false,
                                                    "selections": [
                                                      (v5/*: any*/),
                                                      (v12/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "isPrivate",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "WebFormQuestion",
                                                        "kind": "LinkedField",
                                                        "name": "webFormQuestion",
                                                        "plural": false,
                                                        "selections": [
                                                          (v5/*: any*/),
                                                          (v14/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "richEditorBody",
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "WebFormQuestionOption",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": true,
                                                            "selections": [
                                                              (v5/*: any*/),
                                                              (v19/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Organization",
                                    "kind": "LinkedField",
                                    "name": "organization",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SlackConnection",
                                        "kind": "LinkedField",
                                        "name": "slack",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SlackWorkspace",
                                            "kind": "LinkedField",
                                            "name": "workspace",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "url",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ctaText",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductApp",
                                    "kind": "LinkedField",
                                    "name": "ctaApp",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v17/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "customAppUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Product",
                                        "kind": "LinkedField",
                                        "name": "product",
                                        "plural": false,
                                        "selections": (v20/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Feed",
                                        "kind": "LinkedField",
                                        "name": "feed",
                                        "plural": false,
                                        "selections": (v16/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ChatChannel",
                                        "kind": "LinkedField",
                                        "name": "chatChannel",
                                        "plural": false,
                                        "selections": (v16/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Collection",
                                        "kind": "LinkedField",
                                        "name": "collection",
                                        "plural": false,
                                        "selections": (v16/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsage",
                                        "kind": "LinkedField",
                                        "name": "contentUsage",
                                        "plural": false,
                                        "selections": (v16/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Product",
                                        "kind": "LinkedField",
                                        "name": "linkProduct",
                                        "plural": false,
                                        "selections": (v20/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "entity",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Content",
                                "kind": "LinkedField",
                                "name": "module",
                                "plural": false,
                                "selections": (v16/*: any*/),
                                "storageKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfoObjectType",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v6/*: any*/),
                    "filters": [
                      "includeDraft",
                      "systemTaskKinds"
                    ],
                    "handle": "connection",
                    "key": "MemberOnboardingModal_children",
                    "kind": "LinkedHandle",
                    "name": "children"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "6f2ac229481e949a11d68e302bf6e848",
    "id": null,
    "metadata": {},
    "name": "MemberOnboardingBannerQuery",
    "operationKind": "query",
    "text": "query MemberOnboardingBannerQuery(\n  $membershipId: ID!\n  $includeDraft: Boolean\n  $shouldOnboard: Boolean!\n  $organizationId: ID!\n) {\n  memberOnboarding(membershipId: $membershipId) @include(if: $shouldOnboard) {\n    id\n    ...MemberOnboardingBannerRefetchableFragment_usage\n    ...MemberOnboardingModalFragment_3d4mwG\n    content {\n      id\n      children(includeDraft: $includeDraft) {\n        edges {\n          node {\n            id\n            viewerHasCompleted\n            content {\n              id\n              systemTaskKind\n            }\n          }\n        }\n      }\n    }\n  }\n  organization: node(id: $organizationId) {\n    __typename\n    ... on Organization {\n      id\n      isMemberOnboardingRequired\n    }\n    id\n  }\n}\n\nfragment AppUtils_getLocationFragment on ProductApp {\n  id\n  kind\n  customAppUrl\n  product {\n    slug\n    id\n  }\n  feed {\n    id\n  }\n  chatChannel {\n    id\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  linkProduct {\n    slug\n    id\n  }\n}\n\nfragment DiscoEditorMentionsFragment on Content {\n  id\n  ...EditorMentionsProviderFragment\n}\n\nfragment EditorMentionsProviderFragment on Content {\n  id\n  mentions {\n    edges {\n      node {\n        id\n        user {\n          id\n          fullName\n        }\n        memberGroup {\n          id\n          name\n          kind\n          role\n        }\n        mentionedProduct {\n          id\n          name\n        }\n        mentionedContentUsage {\n          id\n          content {\n            id\n            name\n          }\n        }\n        mentionedOccurrence {\n          id\n          name\n          content {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment InlineContentCoverVideoFormFragment on Content {\n  coverVideoAsset {\n    id\n  }\n}\n\nfragment InlineContentDescriptionSectionFragment on Content {\n  id\n  richEditorDescriptionContent\n  ...DiscoEditorMentionsFragment\n}\n\nfragment InlineContentHeroSectionFormFragment on Content {\n  ...InlineContentCoverVideoFormFragment\n}\n\nfragment InlineContentHeroSectionFragment on Content {\n  ...InlineContentHeroSectionStaticFragment\n  ...InlineContentHeroSectionFormFragment\n}\n\nfragment InlineContentHeroSectionStaticFragment on Content {\n  id\n  coverPhoto\n  coverVideo\n  coverVideoAsset {\n    id\n  }\n  coverVideoAssetUsage {\n    id\n  }\n}\n\nfragment MemberOnboardingBannerRefetchableFragment_usage on ContentUsage {\n  id\n  viewerHasCompleted\n}\n\nfragment MemberOnboardingCalendarContentFragment on ContentUsage {\n  viewerHasCompleted\n  content {\n    systemTaskKind\n    id\n  }\n  ...MemberOnboardingContentHeaderFragment\n  ...useMemberOnboardingFormStoreFragment\n  ...useTrackContentCompletionFragment\n}\n\nfragment MemberOnboardingCommunityAgreementFragment on ContentUsage {\n  id\n  module {\n    id\n  }\n  content {\n    id\n    systemTaskKind\n    richEditorDescriptionContent\n  }\n  ...useMemberOnboardingFormStoreFragment\n}\n\nfragment MemberOnboardingCompleteFragment on ContentUsage {\n  id\n  content {\n    id\n    type\n    systemTaskKind\n    ctaText\n    ctaApp {\n      ...AppUtils_getLocationFragment\n      id\n    }\n    ...InlineContentDescriptionSectionFragment\n  }\n  ...useMemberOnboardingFormStoreFragment\n  ...MemberOnboardingContentHeaderFragment\n}\n\nfragment MemberOnboardingContentFragment_3d4mwG on ContentUsage {\n  id\n  content {\n    id\n    type\n    systemTaskKind\n  }\n  ...MemberOnboardingContentHeaderFragment\n  ...MemberOnboardingGenericTaskFragment\n  ...MemberOnboardingCustomProfileFieldsFragment_3d4mwG\n  ...MemberOnboardingSlackContentFragment\n  ...MemberOnboardingCalendarContentFragment\n  ...MemberOnboardingCommunityAgreementFragment\n  ...MemberOnboardingDefaultProfileFieldsFragment\n  ...MemberOnboardingCompleteFragment\n  ...MemberOnboardingDownloadMobileAppFragment\n}\n\nfragment MemberOnboardingContentHeaderFragment on ContentUsage {\n  content {\n    name\n    description\n    systemTaskKind\n    id\n  }\n}\n\nfragment MemberOnboardingCustomProfileFieldQuestionFragment on ContentUsage {\n  id\n  content {\n    id\n    profileField {\n      id\n      isPrivate\n      webFormQuestion {\n        id\n        type\n        richEditorBody\n        options {\n          id\n          label\n        }\n      }\n    }\n  }\n  ...useMemberOnboardingFormStoreFragment\n}\n\nfragment MemberOnboardingCustomProfileFieldsFragment_3d4mwG on ContentUsage {\n  id\n  ...useMemberOnboardingFormStoreFragment\n  content {\n    systemTaskKind\n    children(includeDraft: $includeDraft) {\n      edges {\n        node {\n          id\n          status\n          viewerHasCompleted\n          content {\n            id\n            profileField {\n              id\n              ordering\n            }\n          }\n          ...MemberOnboardingCustomProfileFieldQuestionFragment\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment MemberOnboardingDefaultProfileFieldsFragment on ContentUsage {\n  content {\n    type\n    systemTaskKind\n    id\n  }\n  ...useMemberOnboardingFormStoreFragment\n}\n\nfragment MemberOnboardingDownloadMobileAppContentFragment on ContentUsage {\n  id\n  content {\n    ...InlineContentHeroSectionFragment\n    id\n  }\n}\n\nfragment MemberOnboardingDownloadMobileAppFragment on ContentUsage {\n  id\n  ...useMemberOnboardingFormStoreFragment\n  ...MemberOnboardingDownloadMobileAppContentFragment\n}\n\nfragment MemberOnboardingGenericTaskFragment on ContentUsage {\n  id\n  content {\n    type\n    systemTaskKind\n    ...InlineContentHeroSectionFragment\n    ...InlineContentDescriptionSectionFragment\n    id\n  }\n  ...useMemberOnboardingFormStoreFragment\n}\n\nfragment MemberOnboardingModalFragment_3d4mwG on ContentUsage {\n  id\n  content {\n    id\n    children(includeDraft: $includeDraft) {\n      edges {\n        node {\n          id\n          ordering\n          viewerHasCompleted\n          status\n          content {\n            id\n            systemTaskKind\n          }\n          ...MemberOnboardingContentFragment_3d4mwG\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment MemberOnboardingSlackAutoConnectSuccessFragment on ContentUsage {\n  content {\n    organization {\n      slack {\n        workspace {\n          name\n          url\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment MemberOnboardingSlackContentFragment on ContentUsage {\n  viewerHasCompleted\n  content {\n    systemTaskKind\n    id\n  }\n  ...useMemberOnboardingFormStoreFragment\n  ...MemberOnboardingContentHeaderFragment\n  ...MemberOnboardingSlackManualConnectionStepsFragment\n  ...MemberOnboardingSlackAutoConnectSuccessFragment\n  ...useTrackContentCompletionFragment\n}\n\nfragment MemberOnboardingSlackManualConnectionStepsFragment on ContentUsage {\n  content {\n    organization {\n      slack {\n        workspace {\n          name\n          url\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  ...MemberOnboardingSlackValidateConnectionFragment\n  ...MemberOnboardingSlackRequestInviteFragment\n}\n\nfragment MemberOnboardingSlackRequestInviteFragment on ContentUsage {\n  ...useMemberOnboardingFormStoreFragment\n}\n\nfragment MemberOnboardingSlackValidateConnectionFragment on ContentUsage {\n  content {\n    organization {\n      slack {\n        workspace {\n          name\n          url\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useMemberOnboardingFormStoreFragment on ContentUsage {\n  id\n  viewerHasCompleted\n}\n\nfragment useTrackContentCompletionFragment on ContentUsage {\n  id\n  entity\n  content {\n    type\n    label\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "17e5a55921b0d540d3fe5e6a42ad8b16";

export default node;
